/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Link } from "react-router-dom";
import robotImage from "../assets/images/bubble.gif";

export default function ChatBot() {
  return (              
      <div className="FullHeight">
        <div className="customChatbot">
          {/* <div id="chatIcon" className="chat-icon">
            <i className="fa-solid fa-comment-dots"></i>
          </div> */}
          <div className="content chatBotContent">
            <div id="typingMessage" style={{ display: "none" }}>
              <div className="typingDots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>

            <img
                src={robotImage}
                style={{ width: "250px" }}
                className="robotImage"
            />

            {/* <div className="chatContent">
              <div>
                <img
                  src={robotImage}
                  style={{ width: "250px" }}
                  className="robotImage"
                />
              </div>

              <div className="commentBox">
                <h3 className="text-center title m-0">
                  Hii, I am Eve{" "}
                  <img
                    src="https://cdn.jsdelivr.net/emojione/assets/png/1f44b.png?v=2.2.7"
                    alt="Waving Hand"
                    style={{ width: "24px", height: "24px", marginBottom: "-2px" }}
                  />
                </h3>
              </div>
            </div> */}

            <div className="d-flex gap-10 items icon-box">
              <Link to="/new-chat">
                <div className="item d-flex">
                  <i className="fa-solid fa-comment-dots"></i> New chat
                </div>
              </Link>
              <Link to="/docs">
                <div className="item d-flex">
                  <i className="fa-solid fa-file-lines"></i> Strategies, policies and prescript documents
                </div>
              </Link>
              <Link to="/faq">
                <div className="item d-flex">
                  <i className="fa-solid fa-circle-question"></i> FAQ's
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>    
  );
}